import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Iframe from 'react-iframe'

const styles = {
 
    card2: {
        alignItems:'center',
        align: 'center',
        boxShadow: 'none',
        border:'none',
        // height:'100%',
        // width:'100vw',
        // minHeight: 700,
        // minWidth: 725,
        marginLeft:'auto',
        marginRight: 'auto'
    },
    myClassname:{

    }
  };

class ChatBoxForReEnter extends Component {

    state={
        height:'30vh',
        width:'30vw'
    }

    componentWillMount(){
        this.setState({
            height:'30vh',
            width:'30vw'
        })
    }
    componentWillUnmount(){
        this.setState({
            height:'30vh',
            width:'30vw'
        })
    }

    componentDidMount() {
        setInterval(()=>{
            this.setState({
                height:'90vh',
                width:'100vw'
            })
        },3000)
    }

    render(){
        const { classes, src } = this.props; 
        let fileURL = "";
        if (localStorage.getItem('language') == "en"){
            fileURL = __dirname + 'chatbotAmendment.html?caseId='+this.props.caseId
            console.log('fileURL: '+fileURL)
        }
        else if (localStorage.getItem('language') == "cn"){
            fileURL = __dirname + 'chatbotAmendmentChi.html?caseId='+this.props.caseId
            console.log('*fileURL: '+fileURL)
        }
        
        return(
            <div style={{height:this.state.height, width:this.state.width}}>
                <Iframe url={fileURL}
                    width="100vw"
                    height="90%"
                    id="myframe"
                    position="relative"
                    className="myClassname"
                />
            </div>
        );
    }
}

export default withStyles(styles)(ChatBoxForReEnter);